import DashboardLayout from "@/components/layouts/DashboardLayout";
import WorkflowBuilder from "@/components/hyperagent/WorkflowBuilder";
import { Button } from "@/components/ui/button";
import { Plus, Wand2 } from "lucide-react";
import { useState } from "react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { priorityIssues } from "@/components/dashboard/PriorityIssues";
import { toast } from "sonner";

const Hyperagent = () => {
  const [workflows, setWorkflows] = useState([
    {
      id: "1",
      name: "Invoice Request Workflow",
      description: "Handle customer invoice and payment status requests",
      steps: priorityIssues[0].workflowTemplate?.steps || [],
    },
  ]);

  const addWorkflow = () => {
    setWorkflows([
      ...workflows,
      {
        id: crypto.randomUUID(),
        name: `New Workflow ${workflows.length + 1}`,
        description: "Start building your automated workflow",
        steps: [],
      },
    ]);
  };

  const createFromTemplate = (issue: typeof priorityIssues[0]) => {
    if (!issue.workflowTemplate) {
      toast.error("No template available for this issue type");
      return;
    }

    setWorkflows([
      ...workflows,
      {
        id: crypto.randomUUID(),
        name: `${issue.title} Workflow`,
        description: issue.description,
        steps: issue.workflowTemplate.steps,
      },
    ]);

    toast.success("Workflow created from template!");
  };

  return (
    <DashboardLayout>
      <div className="space-y-6 h-[calc(100vh-6rem)]">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900 mb-2">
              Hyperagent Workflow Builder
            </h1>
            <p className="text-gray-600">
              Build automated workflows to handle your most common support tickets
            </p>
          </div>
          <div className="flex gap-4">
            <Button onClick={addWorkflow} className="gap-2">
              <Plus className="w-4 h-4" />
              New Workflow
            </Button>
          </div>
        </div>

        {/* Templates Section */}
        <div className="bg-gray-50 rounded-lg p-4">
          <h3 className="text-sm font-medium text-gray-700 mb-3">
            Quick Start from Top Issues
          </h3>
          <div className="flex gap-4 overflow-x-auto pb-2">
            {priorityIssues.map((issue) => (
              <Button
                key={issue.id}
                variant="outline"
                className="gap-2 whitespace-nowrap"
                onClick={() => createFromTemplate(issue)}
              >
                <Wand2 className="w-4 h-4" />
                {issue.title}
              </Button>
            ))}
          </div>
        </div>

        <ScrollArea className="h-[calc(100vh-16rem)] w-full rounded-lg border">
          <div className="flex gap-6 p-6">
            {workflows.map((workflow) => (
              <div
                key={workflow.id}
                className="flex-shrink-0 w-[400px] bg-gray-50 rounded-lg p-4"
              >
                <div className="mb-4">
                  <h3 className="font-medium text-lg text-gray-900">
                    {workflow.name}
                  </h3>
                  <p className="text-sm text-gray-500">{workflow.description}</p>
                </div>
                <WorkflowBuilder initialSteps={workflow.steps} />
              </div>
            ))}
          </div>
        </ScrollArea>
      </div>
    </DashboardLayout>
  );
};

export default Hyperagent;